<template>
    <div>
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Emails</span>
                    </span>
                </h1>
            </div>
        </div>
        <o-table class="is-responsive is-striped is-hoverable" :data="emails">
            <template>
                <o-table-column #default="{ row }" field="name" label="Name" sortable>
                    <a @click.prevent.stop="openEmailModal(row)">{{ row.name }}</a>
                </o-table-column>

                <o-table-column #default="{ row }" field="subject" label="Subject" sortable>
                    {{ getSubject(row.name, row.subject) }}
                </o-table-column>

                <!--<o-table-column field="content" label="Content" v-html="props.row.content">-->
                    <!--&lt;!&ndash; {{ props.row.content }} &ndash;&gt;-->
                <!--</o-table-column>-->
            </template>

          <template #empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEmailModalActive" has-modal-card>
            <email-modal :subject="subject" :url="url"/>
        </o-modal>
    </div>
</template>

<script>
    import Table from './../mixins/Table'
    import EmailModal from './../components/modals/Iframe'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Table],

        components: {
            EmailModal
        },

        data () {
            return {
                isEmailModalActive: false,
                subject: null,
                emails: [],
                url: null
            }
        },

        mounted () {
            axios.get(`/-/emails?message=${encodeURI(this.changeOrderMessage)}`).then(res => this.emails = res.data)
        },

        computed: {
            ...mapGetters({
                changeOrdertext: 'changeOrderMessage'
            })
        },

        methods: {
            openEmailModal(email) {
                this.subject = email.subject
                this.url = `/-/emails/${email.name}?message=${encodeURI(this.changeOrderMessage)}`
                this.isEmailModalActive = true
            },

            getSubject(name, subject) {
                switch (name) {
                    case 'ChangeOrderReady':
                    case 'ProposalMessage':
                        return '[Customizable]'
                    default:
                        return subject
                }
            }
        }
    }
</script>
